export const config = {
  apiUrl: process.env.REACT_APP_API_URL || '/api',
  stripeApiKey: process.env.REACT_APP_STRIPE_API_KEY,
  localStorageKeys: {
    token: 'token',
  },
  loginUrl: process.env.REACT_APP_LOGIN_URL || 'http://site.localtest.me/login',
}
